<template>
<div>
  <div class="wistia_embed wistia_async_3vzx9f114v">
    &nbsp;
  </div>

  <div
    id="first_screen"
    class="tbk-vid-embed"
  >
    <a
      id="romance"
      class="embedded_video"
      href="#wistia_0velnw5lt6?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="opportunity"
      class="embedded_video"
      href="#wistia_aji9mir4l9?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="emergency"
      class="embedded_video"
      href="#wistia_pxcz7om3b0?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('3vz', 20, this.showOverlay)

    this.tbk.loadCrossTime('0ve', 178, this.showOverlay)
    this.tbk.loadCrossTime('aji', 281, this.showOverlay)
    this.tbk.loadCrossTime('pxc', 146, this.showOverlay)

    if (this.tbk.isMobile()) {
      _wq.push({
        '3vz': this.tbk.autoPlay,
        '0ve': this.tbk.autoPlay,
        aji: this.tbk.autoPlay,
        pxc: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showOverlay() {
      $('#first_screen').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang='sass'>
#first_screen
  display: none
  a
    text-decoration: none
#romance
  position: absolute
  top: calc(100% * (100 / 360))
  left: calc(100% * (50 / 640))
  width: calc(100% * (165 / 640))
  height: calc(100% * (190 / 360))
#opportunity
  position: absolute
  top: calc(100% * (100 / 360))
  left: calc(100% * (240 / 640))
  width: calc(100% * (160 / 640))
  height: calc(100% * (190 / 360))
#emergency
  position: absolute
  top: calc(100% * (100 / 360))
  left: calc(100% * (425 / 640))
  width: calc(100% * (160 / 640))
  height: calc(100% * (190 / 360))
</style>

